import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Account from '../views/Account.vue'
import Pay from '../views/Pay.vue'
import PayHandle from '../views/PayHandle.vue'
import LoginSuccess from '../views/LoginSuccess.vue'

Vue.use(VueRouter)

const routes = [
  {
    path:'/',
    redirect:'/pay',
  },
  {
    path: '/pay',
    name: 'pay',
    component: Pay,
  },
  {
    path: '/pay_handle',
    name: 'pay_handle',
    component: PayHandle,
  },
  {
    path: '/login_success',
    name: 'login_success',
    component: LoginSuccess,
  },
]

const router = new VueRouter({
  mode: "history",
  base: "",
  routes
})

// router.beforeEach((to, from, next) => {
//   console.error('------')
//   console.error(to)
//   console.error(from)
//   console.error(next)
//   if (to.matched.length === 0) { //如果未匹配到路由
//     from.name ? next({ name: from.name }) : next('/'); //如果上级也未匹配到路由则跳转登录页面，如果上级能匹配到则转上级路由
//   } else {
//     next(); //如果匹配到正确跳转
//   }
// });


export default router
